export const checkErrors = (error) => {
  if(error.response) {
    switch(error.response.status){
    case '401':
      break;
    default:
      break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/errors.js